import React from 'react';
import { motion } from 'framer-motion';
import { Target, Eye, Award, Users } from 'lucide-react';

const AboutSection = () => {
  const stats = [
    { icon: Users, value: '10,000+', label: 'Pelanggan Puas' },
    { icon: Award, value: '5+', label: 'Tahun Pengalaman' },
    { icon: Target, value: '15+', label: 'Kota Terlayani' },
  ];

  return (
    <section 
      id="tentang" 
      className="py-24 md:py-32 bg-[#0A0A0A]"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden">
              <img 
                src="https://images.unsplash.com/photo-1691435828932-911a7801adfb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxzZXJ2ZXIlMjByb29tJTIwZGF0YSUyMGNlbnRlciUyMGJsdWUlMjBsaWdodGluZ3xlbnwwfHx8fDE3NzI1NDg0OTd8MA&ixlib=rb-4.1.0&q=85"
                alt="Server Infrastructure"
                className="w-full h-[400px] md:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent" />
            </div>

            {/* Floating Card */}
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3, duration: 0.5 }}
              className="absolute -bottom-8 -right-8 glass rounded-xl p-6 max-w-xs hidden md:block"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-brand-blue/20 flex items-center justify-center">
                  <Eye className="w-6 h-6 text-brand-blue" />
                </div>
                <div>
                  <p className="text-2xl font-outfit font-bold text-white">99.9%</p>
                  <p className="text-sm text-gray-400">Uptime Terjamin</p>
                </div>
              </div>
            </motion.div>
          </motion.div>

          {/* Right Column - Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="text-sm font-medium tracking-widest uppercase text-brand-blue mb-4 block">
              Tentang Kami
            </span>
            
            <h2 className="font-outfit text-4xl md:text-5xl font-bold tracking-tight text-white mb-6">
              Menghubungkan <span className="gradient-text-red">Polewali Mandar</span> dengan Dunia
            </h2>
            
            <p className="text-lg text-gray-400 leading-relaxed mb-6">
              <strong className="text-white">Kedai Teknologi Celebes</strong> adalah penyedia layanan internet 
              terkemuka di wilayah Polewali Mandar. Dengan komitmen untuk memberikan koneksi berkualitas tinggi, 
              kami telah melayani banyak pelanggan sejak tahun 2021.
            </p>
            
            <p className="text-gray-400 leading-relaxed mb-8">
              Infrastruktur fiber optik kami yang canggih menjangkau berbagai kota di Polewali Mandar.dari Makassar hingga Manado. Kami percaya bahwa internet cepat dan stabil adalah 
              hak setiap orang, bukan kemewahan.
            </p>

            {/* Vision & Mission */}
            <div className="grid sm:grid-cols-2 gap-6 mb-10">
              <div className="p-5 bg-[#121212] rounded-xl border border-brand-blue/20">
                <div className="icon-container mb-3">
                  <Eye className="w-5 h-5 text-brand-blue" />
                </div>
                <h4 className="font-outfit font-semibold text-white mb-2">Visi</h4>
                <p className="text-sm text-gray-400">
                  Menjadi ISP terdepan di Indonesia Timur dengan layanan berkualitas internasional.
                </p>
              </div>
              <div className="p-5 bg-[#121212] rounded-xl border border-brand-red/20">
                <div className="icon-container icon-container-red mb-3">
                  <Target className="w-5 h-5 text-brand-red" />
                </div>
                <h4 className="font-outfit font-semibold text-white mb-2">Misi</h4>
                <p className="text-sm text-gray-400">
                  Menyediakan akses internet terjangkau dan handal untuk semua kalangan masyarakat.
                </p>
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6">
              {stats.map((stat, index) => {
                const Icon = stat.icon;
                return (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2 + index * 0.1 }}
                    className="text-center"
                  >
                    <div className="w-10 h-10 rounded-lg bg-brand-blue/10 flex items-center justify-center mx-auto mb-3">
                      <Icon className="w-5 h-5 text-brand-blue" />
                    </div>
                    <p className="text-2xl md:text-3xl font-outfit font-bold text-white">{stat.value}</p>
                    <p className="text-xs text-gray-500 mt-1">{stat.label}</p>
                  </motion.div>
                );
              })}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
